<template>
    <div>
        <div class="row">
            <div class="col-lg-6">
                <div class="ticket-border">
                    <div class="ticket-title px-2 py-2">
                        <span class="fw-600">Job Type</span>
                        <span class="pointer" @click="addShowJobTypes()">
                            <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/addlist.svg" alt="">
                        </span>
                    </div>
                    <div class="px-2 py-2" style="max-height: 350px;overflow: scroll;">
                        <ul class="ticket-items pl-0">
                            <li v-if="ajaxCallJT">
                                <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448b" class="text-center w-100 d-flex justify-content-center" style="position:absolute;left:0px"/>
                            </li>
                            <li class="ticket-list text-center py-2" v-if="!ajaxCallJT && jobTypes.length == 0">
                                <span class="w-100 text-center">No Job Types </span>
                            </li>     
                            <li v-else class="ticket-list py-2" v-for="(type,index) in jobTypes" :key="index">
                                <span> <span class="mr-1">{{index+1}}. </span>
                                    <span v-if="type.job_type">{{type.job_type}}</span>
                                </span>
                                <span>
                                    <!-- <span class="pointer" @click="editJT(type.job_type)">
                                        <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/editLimit.svg" alt="">
                                    </span> -->
                                    <span class="pointer" @click="deleteJobType(type)" v-if="!type.job_type.default">
                                        <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/cancelList.svg" alt="">
                                    </span>
                                </span>
                            </li> 
                        </ul>
                        <div class="w-100 pt-3" v-if="showJobType">
                            <input type="text" v-validate="'required'" v-model="job"  name="job_types" class="new-input-setting" placeholder="Job Type">
                            <span class="invalid-feedback-form text-danger" v-show="errors.has('job_types')">{{ errors.first("job_types") }}</span>
                            <div class="mt-3">
                                <a class="btn btn-outline-secondary text-secondary btn-smm mr-0" style="text-transform: uppercase !important;font-size: 12px !important;" @click="jobTypeCancel()">Cancel</a>
                                <button type="button" class="btn btn-secondary btn-smm text-white ml-3" style="box-shadow: none;" v-if="!editJTTrue" @click="jobSave()">Add</button>
                                <button type="button" class="btn btn-secondary btn-smm text-white ml-3" style="box-shadow: none;" v-else @click="jobSaveUpdate()">Update</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Character Limit -->
                <div class="ticket-border mt-8">
                    <div class="ticket-title px-2 py-2">
                        <span class="fw-600">Character Limit</span>
                        <span class="pointer" @click="editCharacter()">
                            <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/editLimit.svg" alt="">
                        </span>
                    </div>
                    <div class="px-2 py-2">
                        <ul class="character-items pl-0 px-3">
                            <li>
                                <div> <span>1.</span> Description</div>
                                <input :readonly="!showCharater" v-on:keypress="isNumber($event)" class="ml-3 px-1 py-1 character-limit" type="number" v-model.number="character_limit.description">
                            </li>
                            <li>
                                <div> <span>2.</span> Notes by technician</div>
                                <input :readonly="!showCharater" v-on:keypress="isNumber($event)" class="ml-3 px-1 py-1 character-limit" type="number" v-model.number="character_limit.notes_by_technician">
                            </li>
                            <li>
                                <div> <span>3.</span> Notes by customer</div>
                                <input :readonly="!showCharater" v-on:keypress="isNumber($event)" class="ml-3 px-1 py-1 character-limit" type="number" v-model.number="character_limit.notes_by_customer">
                            </li>
                            <li>
                                <div><span>4.</span>Caption while uploading attachments</div>
                                <input :readonly="!showCharater" v-on:keypress="isNumber($event)" class="ml-3 px-1 py-1 character-limit" type="number" v-model.number="character_limit.caption_while_uploading_attachments">
                            </li>
                        </ul>
                    </div>
                    <div class="px-2 py-2 text-center" v-if="showCharater">
                        <a class="btn btn-danger btn-smm text-white mr-0" style="text-transform: uppercase !important;font-size: 12px !important;" @click="resetshowCharater()">Reset</a>
                        <button type="button" class="btn btn-success btn-smm text-white ml-3" style="box-shadow: none;" @click="saveshowCharater()">SAVE</button>
                    </div>
                </div>
                <!-- Create ticket on behalf of  -->
                <div class="ticket-border mt-8">
                    <div class="ticket-title px-2 py-2">
                        <span class="fw-600">Create ticket on behalf of ? <span class="text-danger pl-1">*</span></span>
                    </div>
                    <div class="px-2 ">
                          <div class="py-2">
                            <el-checkbox  label="Myself" v-model="behalf_of_checkList.create_ticket_on_behalf_of.Myself" :checked="behalf_of_checkList.create_ticket_on_behalf_of.Myself"></el-checkbox>
                           </div> <div class="py-2"><el-checkbox label="Vendor" v-model="behalf_of_checkList.create_ticket_on_behalf_of.Vendor" :checked="behalf_of_checkList.create_ticket_on_behalf_of.Vendor" ></el-checkbox>
                           </div><div class="py-2"> <el-checkbox label="Customer" v-model="behalf_of_checkList.create_ticket_on_behalf_of.Customer" :checked="behalf_of_checkList.create_ticket_on_behalf_of.Customer"></el-checkbox>
                    </div></div>
                </div>
                <!-- Success logo -->
                <div class="ticket-border mt-8">
                    <div class="ticket-title px-2 py-2">
                        <span class="fw-600">Image for success message (Maximum size supports 300*400) </span>
                    </div>
                    <div class="px-2 py-2">
                        <el-radio-group v-model="successImg.default" class="radiogroupcol">
                            <el-radio :label="true">Default(Bird)</el-radio>
                            <span class="mb-2" style="border-top:2px solid #cbe3fd"></span>
                            <el-radio :label="false">Custom</el-radio>
                        </el-radio-group>
                        <div class="logo-btn" v-if="successImg.default == false">
                            <div class="d-flex justify-content-end">
                                <div class="text-center bg-white">
                                    <label class="choose-file mt-1" style="font-family: 'Poppins';">
                                        <input type="file" id="multiple" multiple @change="uploadAttachmentSingle" accept=".png,.jpg,image/*">
                                        Upload Logo
                                    </label>
                                </div>
                            </div>
                            <div class="signaturebg mt-3" v-if="singleAttachment">
                                <div class="text-center m-2 p-2"> 
                                    <img :src="singleAttachment.url" alt="" style="height:50px;width:100px">
                                </div>
                                <div v-if="singleAttachment.uploading || singleAttachment.url == undefined" class="pl-5">
                                    <progress-bar class="progressBar w-80" :class="{'error-upload':singleAttachment.url == undefined}" :val="singleAttachment.progress" size="small"></progress-bar>
                                </div>    
                                <div class="d-flex justify-content-between pl-5">
                                    <div class="text-danger pl-0 fw-500" v-if="singleAttachment.error != ''">{{singleAttachment.error}}...</div>
                                    <div class="text-secondary fw-500" v-if="singleAttachment.progress<100 && singleAttachment.error == ''">{{singleAttachment.progress}}% Uploading</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Reject Logo -->
                <div class="ticket-border mt-8">
                    <div class="ticket-title px-2 py-2">
                        <span class="fw-600">Image for failure message (Maximum size supports 300*400)</span>
                    </div>
                    <div class="px-2 py-2">
                        <el-radio-group v-model="rejectImg.default" class="radiogroupcol">
                            <el-radio :label="true">Default(Dog)</el-radio>
                            <span class="mb-2" style="border-top:2px solid #cbe3fd"></span>
                            <el-radio :label="false">Custom</el-radio>
                        </el-radio-group>
                        <div class="logo-btn" v-if="rejectImg.default == false ">
                            <div class="d-flex justify-content-end">
                                <div class="text-center bg-white">
                                    <label class="choose-file mt-1" style="font-family: 'Poppins';">
                                        <input type="file" id="multiple" multiple @change="uploadAttachmentSingleNew" accept=".png,.jpg,image/*">
                                        Upload Logo
                                    </label>
                                </div>
                            </div>
                            <div class="signaturebg mt-3" v-if="singleAttachmentNew">
                                <div class="text-center m-2 p-2"> 
                                    <img :src="singleAttachmentNew.url" alt="" style="height:50px;width:100px">
                                </div>
                                <div v-if="singleAttachmentNew.uploading || singleAttachmentNew.url == undefined" class="pl-5">
                                    <progress-bar class="progressBar w-80" :class="{'error-upload':singleAttachmentNew.url == undefined}" :val="singleAttachmentNew.progress" size="small"></progress-bar>
                                </div>    
                                <div class="d-flex justify-content-between pl-5">
                                    <div class="text-danger pl-0 fw-500" v-if="singleAttachmentNew.error != ''">{{singleAttachmentNew.error}}...</div>
                                    <div class="text-secondary fw-500" v-if="singleAttachmentNew.progress<100 && singleAttachmentNew.error == ''">{{singleAttachmentNew.progress}}% Uploading</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="ticket-border mr-2">
                    <div class="ticket-title px-2 py-2">
                        <span class="fw-600">Ticket Status</span>
                        <span class="pointer" @click="addStatus()">
                            <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/addlist.svg" alt="">
                        </span>
                    </div>
                    <div class="px-2 py-2">
                        <ul class="ticket-items pl-0">
                            <li class="text-center" v-if="ajaxCallStatus">
                                <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448b" class="text-center w-100 d-flex justify-content-center" style="position:absolute;left:0px"/>
                            </li>
                            <li class="ticket-list text-center py-2" v-if="!ajaxCallStatus && status_options.length == 0">
                                <span class="w-100 text-center">No Ticket Status</span>
                            </li>
                            <li v-else class="ticket-list py-2" v-for="(item,sIndex) in status_options" :key="sIndex">
                                <span> <span class="mr-1">{{sIndex+1}}.</span>
                                    <span v-if="item.ticket_status">{{item.ticket_status}}</span>
    
                                </span>
                                <span>
                                    <!-- <span class="pointer" @click="editStatus(item.ticket_status)">
                                        <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/editLimit.svg" alt="">
                                    </span> -->
                                    <span class="pointer" @click="removeStatus(item)">
                                        <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/cancelList.svg" alt="">
                                    </span>
                                </span>
                            </li>
                        </ul>
                    </div>
                    <div class="px-2 py-2" v-if="status">
                        <input type="text" v-validate="'required'" v-model="statusName" name="statusName"  class="new-input-setting">
                        <span class="invalid-feedback-form text-danger" v-show="errors.has('statusName')">{{ errors.first("statusName") }}</span>
                        <div class="mt-3">
                            <a class="btn btn-outline-secondary text-secondary btn-smm mr-0" style="text-transform: uppercase !important;font-size: 12px !important;" @click="statusCancel()">Cancel</a>
                            <button type="button" class="btn btn-secondary btn-smm text-white ml-3" v-if="!editStatusTrue" style="box-shadow: none;" @click="statusAdd()">Add</button>
                            <button type="button" class="btn btn-secondary btn-smm text-white ml-3" v-else style="box-shadow: none;" @click="statusUpdate()">Update</button>
                        </div>
                    </div>
                </div>
                <div class="ticket-border mt-5 mr-2">
                    <div class="ticket-title px-2 py-2">
                        <span class="fw-600">Service Ticket Naming Convention</span>
                    </div>
                    <div class="px-3 py-3">
                        <!-- <div>
                            <div class="d-flex align-items-center">
                                <input type="radio" v-model="api_number.service_ticket_naming_convention" value="alphabet">
                                <span class="pl-5">Alphabets</span>
                            </div>
                            <span class="pl-8" style="color:#616161">Ex : #500.A , #500.B, etc</span>
                        </div>
                        <div>
                            <div class="d-flex align-items-center mt-4">
                                <input type="radio" v-model="api_number.service_ticket_naming_convention" value="numeric">
                                <span class="pl-5">Numericals</span>
                            </div>
                            <span class="pl-8" style="color:#616161">Ex : #500.1, #500.2, etc</span>
                        </div> -->
                        <el-radio-group v-model="api_number.service_ticket_naming_convention" class="radiogroupcol">
                            <el-radio label="alphabet">
                                Alphabets <br>
                                <span class="pl-8" style="color:#616161">Ex : #500.A , #500.B, etc</span>
                            </el-radio>
                            <el-radio label="numeric">
                                Numericals <br>
                                <span class="pl-8" style="color:#616161">Ex : #500.1, #500.2, etc</span>
                            </el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <div class="ticket-border mt-5 mr-2">
                    <div class="ticket-title px-2 py-2">
                        <span class="fw-600">Display current user name while editing ticket</span>
                    </div>
                    <div class="px-3 py-3">
                        <!-- <div>
                            <div class="d-flex align-items-center">
                                <input type="radio" v-model="api_edit_ticket.display_current_user_name_while_editing_ticket" value="true">
                                <span class="pl-5">Yes</span>
                            </div>
                        </div>
                        <div>
                            <div class="d-flex align-items-center mt-4">
                                <input type="radio" v-model="api_edit_ticket.display_current_user_name_while_editing_ticket" value="false">
                                <span class="pl-5">No</span>
                            </div>
                        </div> -->
                        <el-radio-group v-model="api_edit_ticket.display_current_user_name_while_editing_ticket" class="radiogroupcol">
                            <el-radio :label="true">
                                Yes
                            </el-radio>
                            <el-radio :label="false">
                                No
                            </el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <!-- Display priority -->
                <div class="ticket-border mt-5 mr-2">
                    <div class="ticket-title px-2 py-2">
                        <span class="fw-600">Display ticket priorities </span>
                    </div>
                    <!-- <div class="px-2 py-2">
                        <el-radio-group v-model="displayPriority.display_ticket_priorities" class="radiogroupcol">
                            <el-radio :label="true">Yes</el-radio>
                            <el-radio :label="false">No</el-radio>
                        </el-radio-group>
                    </div> -->
                    <div class="px-3 py-3">
                        <!-- <div>
                            <div class="d-flex align-items-center">
                                <input type="radio" class="pointer" v-model="displayPriority.display_ticket_priorities" :value="yes">
                                <span class="pl-5 pointer">Yes</span>
                            </div>
                        </div>
                        <div>
                            <div class="d-flex align-items-center mt-4">
                                <input type="radio" class="pointer" v-model="displayPriority.display_ticket_priorities" :value="no">
                                <span class="pl-5 pointer">No</span>
                            </div>
                        </div> -->
                        <el-radio-group v-model="displayPriority.display_ticket_priorities" class="radiogroupcol">
                            <el-radio :label="true">
                                Yes
                            </el-radio>
                            <el-radio :label="false">
                                No
                            </el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <!-- Send Approval -->
                <div class="ticket-border mt-5 mr-2">
                    <div class="ticket-title px-2 py-2">
                        <span class="fw-600">Send approval alerts to ? <span class="text-danger pl-1">*</span></span>
                    </div>
                    <div class="px-2 column">
                       
                          <div class="py-2"> <el-checkbox label="Customer" v-model="sendApproval.send_approval_alerts_to.Customer" :checked="sendApproval.send_approval_alerts_to.Customer"></el-checkbox>
                           </div><div class="py-2"> <el-checkbox label="Technician" v-model="sendApproval.send_approval_alerts_to.Technician" :checked="sendApproval.send_approval_alerts_to.Technician"></el-checkbox>
                           </div><div class="py-2"> <el-checkbox label="Supervisor" v-model="sendApproval.send_approval_alerts_to.Supervisor" :checked="sendApproval.send_approval_alerts_to.Supervisor"></el-checkbox>
                          </div><div class="py-2">  <el-checkbox label="Manager" v-model="sendApproval.send_approval_alerts_to.Manager" :checked="sendApproval.send_approval_alerts_to.Manager"></el-checkbox>
                           </div><div class="py-2"> <el-checkbox label="Director" v-model="sendApproval.send_approval_alerts_to.Director" :checked="sendApproval.send_approval_alerts_to.Director"></el-checkbox>
                           </div><div class="py-2"> <el-checkbox label="Admin" v-model="sendApproval.send_approval_alerts_to.Admin" :checked="sendApproval.send_approval_alerts_to.Admin"></el-checkbox>
                       </div>
                    </div>
                </div>
                <!--Assignment of PM  -->
                <div class="ticket-border mt-10 mr-2">
                    <div class="ticket-title px-2 py-2">
                        <span class="fw-600">Assignment of Preventive Maintenance ticket?</span>
                    </div>
                    <div class="px-2 py-2">
                        <el-radio-group v-model="pmTicket.assignment_of_preventive_maintenance_ticket" class="radiogroupcol">
                            <el-radio label="start_of_the_week">Start of the week</el-radio>
                            <el-radio label="start_of_the_month">Start of the Month</el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <div class="ticket-border mt-10 mr-2">
                    <div class="ticket-title px-2 py-2">
                        <span class="fw-600">Display Priority or Job Type In Ticket Cards<span class="text-danger pl-1">*</span>  </span>
                    </div>
                    <div class="px-2 py-2">
                        <el-radio-group v-model="show_below_options_in_ticket_cards.ticket_cards" class="radiogroupcol">
                            <el-radio label="job_type">Job Type</el-radio>
                            <el-radio label="priority">Priority</el-radio>
                        </el-radio-group>
                    </div>
                </div>
            </div>
            <div class="px-2 py-2 mt-6 text-center w-100">
                <a class="btn btn-danger btn-smm text-white mr-0" style="text-transform: uppercase !important;font-size: 12px !important;" @click="reset()">Reset</a>
                <button type="button" class="btn btn-success btn-smm text-white ml-3" style="box-shadow: none;" @click="save()">SAVE</button>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
import setting from '../mixins/setting';
import Swal from 'sweetalert2';
import {SweetModal} from 'sweet-modal-vue'
import FileUpload from 'vue-upload-component';
import attachment from "../mixins/attachments.js";

export default {
    mixins:[setting,attachment],
    components:{
        SweetModal,
        Swal,
        FileUpload
    },
    data(){
        return{
            success_msg:'',
            warning_msg:'',
            showJobType:false,
            jobTypes:[],
            job:'',
            status:false,
            showCharater:false,
            ajaxCallJT:false,
            ajaxCallStatus:false,
            status_options:[],
            statusName:'',
            character_limit:{},
            api_character_limit:{},
            editDetailsJT:'',
            editJTTrue:false,
            editDetailsStatus:'',
            editStatusTrue:false,
            service_ticket_naming_convention:'number',
            api_number:'number',
            display_current_user_name_while_editing_ticket:false,
            api_edit_ticket:false,
            behalf_of_checkList:{},
            successImg:{},
            rejectImg:{},
            pmTicket:"month",
            yes:true,
            no:false,
            displayPriority:false,
            display_ticket_priorities:false,
            sendApproval:[],
            temp_attachments:[],
            accept: '*',
            extensions: '*',
            size: 1024 * 1024 * 10,
            multiple: true,
            directory: true,
            drop: true,
            dropDirectory: true,
            addIndex: false,
            thread: 3,
            name: 'file',
            postAction: '/upload/post',
            putAction: '/upload/put',
            headers: {
                'X-Csrf-Token': 'xxxx',
            },
            data: {
                '_csrf_token': 'xxxxxx',
            },
            autoCompress: 1024 * 1024,
            uploadAuto: false,
            isOption: false,
            attachments:[],
            singleAttachment:'',
            singleAttachmentNew:'',
            show_below_options_in_ticket_cards:'job_type'
        }
    },
    methods:{
        editJT(value){
            this.editDetailsJT = value
            this.job = value.name
            this.showJobType = true
            this.editJTTrue = true
        },
        editStatus(value){
            this.editDetailsStatus = value
            this.statusName = value.name
            this.status = true
            this.editStatusTrue = true
        },
        addShowJobTypes(){
            this.showJobType = true
            this.job = ""
        },
        jobSaveUpdate(){
            this.$validator.validateAll().then(result => {
                if (result == true){
                    this.confirmUpdateJT()
                }else{
                    // this.$toasted.global.error("Please Fill All The Required Fields")
                }
            })
        },
        async confirmUpdateJT(){
            try {
                let params = {
                    default:this.editDetailsJT.default || false,
                    job_type:{
                        name:this.job
                    },
                    job_type_id:this.editDetailsJT._id
                }
                let res = await this.updateJobType(params)
                this.success_msg = res.response
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.getAllDetails();
                }, 3000);
                this.jobTypeCancel()
            } catch (reason) {
                this.warning_msg = reason
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        jobSave(){
            this.$validator.validateAll().then(result => {
                if (result == true){
                    this.confirmSaveJT()
                }else{
                    // this.$toasted.global.error("Please Fill All The Required Fields")
                }
            })
        },
        async confirmSaveJT(){
            try {
                let params = {
                    default:false,
                    job_type:this.job
                
                }
                let res = await this.addJobType(params)
                this.success_msg = res.response.success_message
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.getAllDetails();
                }, 3000);
                this.jobTypeCancel()
            } catch (reason) {
                this.warning_msg = reason
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        jobTypeCancel(){
            this.showJobType = false
            this.job = ""
            this.editDetailsJT = ''
            this.editJTTrue = false
        },
        deleteJobType(item){
            Swal.fire({
                title: 'Alert',
                text: "Are you sure want to delete" + ' ' + JSON.stringify(item.job_type) + "?",
                type: 'warning',
                icon: 'warning',
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText:'YES',
                cancelButtonText:'NO'
            }).then((result) => {
                if (result.value) {

                    let params = {
                        _id:item._id,
                        settings_type: item.settings_type
                    }

                    this.confirmDelete(params)
                }
            })
        },
        async confirmDelete(params){
            try {
                let res = await this.jobTypeDelete(params)
                this.success_msg = res.response
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.getAllDetails();
                }, 3000);
            } catch (reason) {
                this.warning_msg = reason
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        removeStatus(item){
            Swal.fire({
                title: 'Alert',
                text: "Are you sure want to delete" + ' ' + JSON.stringify(item.ticket_status) + "?",
                type: 'warning',
                icon: 'warning',
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText:'YES',
                cancelButtonText:'NO'
            }).then((result) => {
                if (result.value) {
                    let params = {
                        _id:item._id,
                        settings_type:item.settings_type
                    }

                    this.confirmDeleteStatus(params)
                }
            })
        },
        async confirmDeleteStatus(params){
            try {
                let res = await this.statusDelete(params)
                this.success_msg = res.response
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.getAllDetails();
                }, 3000);
            } catch (reason) {
                this.warning_msg = reason
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        addStatus(){
            this.status = true
            this.statusName = ''
        },
        statusCancel(){
            this.status = false
            this.statusName = ''
            this.editStatusTrue = false
            this.editDetailsStatus = true
        },
        statusUpdate(){
            this.$validator.validateAll().then(result => {
                if (result == true){
                    this.confirmUpdateStatus()
                }else{
                    // this.$toasted.global.error("Please Fill All The Required Fields")
                }
            })
        },
        async confirmUpdateStatus(){
            try {
                let params = {
                    default:false,
                    ticket_status:this.statusName,
                    ticket_status_id:this.editDetailsStatus._id
                }
                let res = await this.updateTicketStatus(params)
                this.success_msg = res.response
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.getAllTicketStatusAPI();
                }, 3000);
                this.statusCancel()
            } catch (reason) {
                this.warning_msg = reason
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        statusAdd(){
            this.$validator.validateAll().then(result => {
                if (result == true){
                    this.confirmSaveStatus()
                }else{
                    // this.$toasted.global.error("Please Fill All The Required Fields")
                }
            })
        },
        async confirmSaveStatus(){
            try {
                let params = {

                        default:false,
                        ticket_status:this.statusName
                }
                let res = await this.addTicketStatus(params)
                this.success_msg = res.response.success_message
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.getAllDetails();
                }, 3000);
                this.statusCancel()
            } catch (reason) {
                this.warning_msg = reason
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        editCharacter(){
            if(this.showCharater){
                this.showCharater = false
                this.resetshowCharater()
            }else{
                this.showCharater = true
            }
            
        },
        resetshowCharater(){
            this.character_limit = JSON.parse(
                JSON.stringify({
                    _id:this.api_character_limit._id,
                    settings_type:this.api_character_limit.settings_type,
                    caption_while_uploading_attachments : this.api_character_limit.caption_while_uploading_attachments,
                    default:this.api_character_limit.default,
                    description:this.api_character_limit.description,
                    notes_by_customer:this.api_character_limit.notes_by_customer,
                    notes_by_technician:this.api_character_limit.notes_by_technician
                })
            )
        },
        async saveshowCharater(){
            try {
                let params = {
                    payload:[this.character_limit]
                }
                let res = await this.updateCharacterLimit(params)
                this.success_msg = res.response
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.getAllDetails()
                }, 3000);
                this.showCharater = false
            } catch (reason) {
                this.warning_msg = reason
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        isNumber: function(evt, index) {
            evt = evt ? evt : window.event
            var charCode = evt.which ? evt.which : evt.keyCode
            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                evt.preventDefault()
            } else {
                return true
            }
        },
        async getAllDetails(){
            try {
                let params = {
                    settings_type: [
                        "service_ticket_naming_convention",
                        "assignment_of_preventive_maintenance_ticket",
                        "ticket_status",
                        "job_type",
                        "display_ticket_priorities",
                        "display_current_user_name_while_editing_ticket",
                        "image_for_failure_message",
                        "image_for_success_message",
                        "create_ticket_on_behalf_of",
                        "character_limit",
                        "send_approval_alerts_to",
                        "can_multiple_people_edit_the_same_ticket_at_the_same_time",
                        "ticket_cards"
                    ]
                }
                this.ajaxCallJT = true
                let data = await this.getAllJobTypes(params)
                let res = data.response;
                this.sendApproval = res.send_approval_alerts_to,
                this.jobTypes = res.job_type
                this.ajaxCallStatus = true
                this.status_options = res.ticket_status
                this.ajaxCallStatus = false
                this.ajaxCallJT = false
                this.behalf_of_checkList = res.create_ticket_on_behalf_of,
        
                this.displayPriority = res.display_ticket_priorities,
                this.successImg = res.image_for_success_message,
                this.rejectImg = res.image_for_failure_message,
                this.pmTicket = res.assignment_of_preventive_maintenance_ticket,
                this.api_character_limit = res.character_limit
                this.resetshowCharater()
                this.api_edit_ticket = res.display_current_user_name_while_editing_ticket
                this.api_number = res.service_ticket_naming_convention
                this.show_below_options_in_ticket_cards = res.ticket_cards
                // this.reset()
            } catch (reason) {
                
            }
        },
        // async getAllTicketStatusAPI(){
        //     try {
        //         this.ajaxCallStatus = true
        //         let res = await this.getAllTicketStatus()
        //         this.status_options = res.response
        //         this.ajaxCallStatus = false
        //     } catch (reason) {
                
        //     }
        // },
        // async getCharacterLimitAPI(){
        //     try {
        //         let res = await this.getCharacterLimit()
        //         this.api_character_limit = res.response.character_limit
        //         this.resetshowCharater()
        //     } catch (reason) {
                
        //     }
        // },
        // async getNamingConventionAPI(){
        //     try {
        //         let res = await this.getNamingConvention()
        //         this.api_number = res.response
        //         this.reset()
        //     } catch (reason) {
                
        //     }
        // },
        // async getUserNameEditTicketAPI(){
        //     try {
        //         let res = await this.getUserNameEditTickets()
        //         this.api_edit_ticket = res.response
        //         this.reset()
        //     } catch (reason) {
                
        //     }
        // },
        async confirmSave(){
            try {
               let params = {
                   payload:[{
                   _id:this.api_edit_ticket._id,
                   settings_type:display_current_user_name_while_editing_ticket,
                   display_current_user_name_while_editing_ticket:this.display_current_user_name_while_editing_ticket
                }]} 
                let res = await this.updateUserNameEditTickets(params)
                this.success_msg = res.response
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.getAllDetails();
                }, 3000);
            } catch (reason) {
                this.warning_msg = reason
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        async confirmSaveNaming(){
            try {
               let params = { payload:[{
                    settings_type:this.api_number.settings_type,
                    _id:this.api_number._id,
                    service_ticket_naming_convention:this.service_ticket_naming_convention
               }] } 
                let res = await this.updateNamingConvention(params)
                this.success_msg = res.response
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.getAllDetails();
                }, 3000);
            } catch (reason) {
                this.warning_msg = reason
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
       async save(){
             try {
               let params = { payload:[this.sendApproval,this.behalf_of_checkList,this.successImage,this.rejectImage,this.api_edit_ticket,this.api_number,this.pmTicket, this.displayPriority,this.show_below_options_in_ticket_cards] }; 

                this.$store.commit("setShowPriroty", this.displayPriority);
                this.$store.commit("setShowPicture", this.successImage);
              let res = await this.updateNamingConvention(params)
                this.success_msg = res.response
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.getAllDetails();
                }, 3000);
             } catch (reason) {
                 this.warning_msg = reason
                 this.$refs.warning_modal.open();
                 setTimeout(() => {
                 this.$refs.warning_modal.close();
                }, 3000);
            }
            // if(this.service_ticket_naming_convention != this.api_number.service_ticket_naming_convention){
            //     this.confirmSaveNaming()
            // }
            // if(this.display_user_name_edit_ticket != this.api_edit_ticket.display_user_name_edit_ticket){
            //     this.confirmSave() 
            // }
            // if(this.service_ticket_naming_convention == this.api_number.service_ticket_naming_convention && this.display_user_name_edit_ticket == this.api_edit_ticket.display_user_name_edit_ticket){
            //     this.$toasted.global.error("Please make necessary changes and update")
            // }
            //  try {
            //    let params = { payload:[

            //    ] } 
            //     let res = await this.updateAllDetails(params)
            //     this.success_msg = res.response
            //     this.$refs.success_modal.open();
            //     setTimeout(() => {
            //         this.$refs.success_modal.close();
            //         this.getAllDetails();
            //     }, 3000);
            // } catch (reason) {
            //     this.warning_msg = reason
            //     this.$refs.warning_modal.open();
            //     setTimeout(() => {
            //         this.$refs.warning_modal.close();
            //     }, 3000);
            // }

        },
        reset(){
            this.getAllDetails()
            this.service_ticket_naming_convention = this.api_number.service_ticket_naming_convention
            this.display_current_user_name_while_editing_ticket = this.api_edit_ticket.display_current_user_name_while_editing_ticket
            this.getAllDetails();
        },
        inputFile(newFile, oldFile) {
            this.temp_attachments = []
            if (newFile && oldFile) {
                if (newFile.active && !oldFile.active) {
                if (newFile.size >= 0 && this.minSize > 0 && newFile.size < this.minSize) {
                    this.$refs.upload.update(newFile, { error: 'size' })
                }
                }
                if (newFile.progress !== oldFile.progress) {
                }
                if (newFile.error && !oldFile.error) {
                }
                if (newFile.success && !oldFile.success) {
                }
            }
            if (!newFile && oldFile) {
                if (oldFile.success && oldFile.response.id) {
                }
            }
            if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
                if (this.uploadAuto && !this.$refs.upload.active) {
                this.$refs.upload.active = true
                }
            }
            this.input_file = newFile.file
            this.uploadAttachment(event)
        },
    },
    async mounted(){
        this.getAllDetails()
        // this.getAllTicketStatusAPI()
        // this.getCharacterLimitAPI()
        // this.getUserNameEditTicketAPI()
        // this.getNamingConventionAPI()
    },

    computed:{    
        successImage(){
                if(this.singleAttachment.url){
                this.successImg.url = this.singleAttachment.url;
                this.successImg.custom = !this.successImg.default;
                } 
               return this.successImg;
            
        },
        rejectImage(){
                if(this.singleAttachmentNew.url){
                this.rejectImg.url = this.singleAttachmentNew.url;
                this.rejectImg.custom = !this.rejectImg.default;
                } 
               return this.rejectImg;
            
        }
    },
    created(){
        const dict = {
            custom: {
                job_types:{
                    required:() => "Job Type Name is Required",
                },
                statusName:{
                    required:() => "Status Name is Required"
                }
            }
        }
        this.$validator.localize("en", dict); 
    },
}
</script>
<style scoped>
.ticket-border{
    border: 0.5px solid #cbe3fd !important;
    border-radius: 5px;
}
.ticket-list{
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #cbe3fd;
}
.ticket-title{
    background-color: #cbe3fd;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.new-input-setting{
    border: 1px solid #216ad8;
    width: 100%;
    padding: 7px;
    border-radius: 5px;
}
.ticket-items li{
    list-style: none;
}
.character-items li{
    list-style: none;
    border-bottom: 2px solid #cbe3fd;
    padding: 10px 0px;
}
.character-limit{
    border: 1px solid #216ad8 !important;
    border-radius: 15px !important;
    width: 100px;
    margin-top: 5px;
    text-align: center;
}
input.character-limit:focus{
    border: 1px solid #005dae !important;
    border-radius: 15px !important;
    outline: none;
}
.logo-btn{        
    position: relative;
    top: -33px;
}
.message-image{
    border: 1px solid #000000;
    border-radius: 4px;
    padding: 10px;
}
</style>